let skioExist = true;  
let picker_triggers = document.querySelectorAll('.item__add-to-cart');
let close_triggers = document.querySelectorAll('.close__variant__picker');
let picker_wrapper = document.querySelectorAll('.collection__variant-picker');
let picker_wrapper_section = document.querySelector('.collection-slider-container .collection__variant-picker') || false;
let picker_modals = document.querySelectorAll('.variant-picker__wrapper');
let variant_btns = document.querySelectorAll('.variant-picker__subscription-type .variant__label');
let subscription_type_btns = document.querySelectorAll('.variant-picker__subscription-type .subscription__type');

let frequency_selectors = document.querySelectorAll('.frequency__selector');
let variant_picker_atc = document.querySelectorAll('.variant-picker__ctas .product-form__submit');

const openPickerModal = event => {
    event.preventDefault();
    if (event.target.closest('.collection-slider-container')){
        picker_wrapper_section && picker_wrapper_section.classList.add('active');
    }else{
        picker_wrapper.forEach(el => el.dataset.section == event.target.closest('.item__add-to-cart').dataset.section && el.classList.add('active'));
    }
    
    picker_modals.forEach(el => {
        if (event.target.closest('.item__add-to-cart').dataset.picker == el.dataset.picker && event.target.closest('.item__add-to-cart').dataset.section == el.dataset.section){
            el.classList.add('active');
        }
    });

    document.body.style.overflow = 'hidden';
    document.querySelector('#transcySwitcherContainer') &&  document.querySelector('#transcySwitcherContainer').classList.add('hidden');
    document.querySelector('#gorgias-chat-container') &&  document.querySelector('#gorgias-chat-container').classList.add('hidden');
    document.getElementById('shopify-section-header').classList.add('shopify-section-header-hidden');
}

const closePickerModal = event => {
    if (event.target.closest('.variant-picker__ctas .product-form__submit') || event.target.closest('.close__variant__picker') || !event.target.closest('.variant-picker__wrapper')){
        picker_modals.forEach(el => el.classList.remove('active'));
        picker_wrapper.forEach(el => el.classList.remove('active'));
        picker_wrapper_section && picker_wrapper_section.classList.remove('active');
    }
    if (event.target.closest('.variant-picker__ctas .product-form__submit')) {
        document.querySelector('.loading-spinner').classList.add('active');
        document.querySelector('.cart__details').classList.add('opacity-06');
    }

    document.body.style.overflow = '';
    document.querySelector('#transcySwitcherContainer') &&  document.querySelector('#transcySwitcherContainer').classList.remove('hidden');
    document.querySelector('#gorgias-chat-container') &&  document.querySelector('#gorgias-chat-container').classList.remove('hidden');
}

const setActiveBtn = event => {

    let target = event.target.closest('.variant__label') || event.target.closest('.subscription__type');
    let target_parent = target.parentNode;
    
    if (target.classList.contains('variant__label')) target_parent.querySelectorAll('.variant__label').forEach(el => el.classList.remove('selected'));
    if (target.classList.contains('subscription__type')) target_parent.querySelectorAll('.subscription__type').forEach(el => el.classList.remove('selected'));
    target.classList.add('selected');    
    
    findSelectedVariant(parseProductDetails());

    //if (target.classList.contains('subscription__type') || target.closest('.option-2') || target.closest('.option-3')) updatePrice();

}

const updatePrice = (variant_id) => {
    let selected_variant_wrapper = document.querySelector('.variant-picker__wrapper.active');
    let selected_type = selected_variant_wrapper.querySelector('.subscription-type__selectors .subscription__type.selected').dataset.type;
    let selected_product_prices = selected_variant_wrapper.querySelectorAll('.label-price');
    let newPrice;

    if (selected_variant_wrapper.querySelector('.option-2')) {
        parseProductDetails().variants.forEach(variant => {
            if (variant.id == variant_id){
                selected_product_prices.forEach(price => {
                    if (price.dataset.type == 'subscription') newPrice = variant.selling_plan_allocations[0].per_delivery_price / 100;
                    if (price.dataset.type == 'onetimer') newPrice = variant.price / 100;

                    price.innerHTML = newPrice + `${locales_variables.currency_symbol}`;
                });
            }
        });
    }

    selected_product_prices.forEach(price => {
        price.dataset.type == selected_type ? price.classList.remove('hidden') : price.classList.add('hidden');
    });
    

   calculateDiscount();
}

const calculateDiscount = () => {
    let selected_variant_wrapper = document.querySelector('.variant-picker__wrapper.active');
    let selected_type = selected_variant_wrapper.querySelector('.subscription__type.selected').dataset.type;
    let discounts = selected_variant_wrapper.querySelectorAll('.subscription__type--discount span');
    let selected_package = selected_variant_wrapper.querySelector('.option-1 .variant__label.selected');

    if (selected_type == 'subscription' && +selected_package.dataset?.discountSubscription > 0){
        discounts.forEach(discount => {
            discount.textContent = selected_package.dataset.discountSubscription;
            discount.closest('.subscription__type[data-type="subscription"]') ? 
            discount.parentNode.classList.remove('hidden') : 
            discount.parentNode.classList.add('hidden');
        });
    }else if (selected_type == 'onetimer' && +selected_package.dataset?.discountOnetimer > 0){
        discounts.forEach(discount => {
            discount.textContent = selected_package.dataset.discountOnetimer;
            discount.closest('.subscription__type[data-type="onetimer"]') ? 
            discount.parentNode.classList.remove('hidden') : 
            discount.parentNode.classList.add('hidden');
        });
    }else {
        discounts.forEach(discount => discount.parentNode.classList.add('hidden') );
    }
}

const extractText = content=> {
    let parser = new DOMParser();
    let doc = parser.parseFromString(content, 'text/html');
    if (doc.body && doc.body.childNodes.length > 0) {
        return doc.body.textContent;
    }
    return content;
}

const checkSellingPlan = event => {
    setActiveBtn(event);

    let target = event.target.closest('.subscription__type');
    let plan = target.dataset.type;
    let parent = target.parentNode.parentNode;

    if (plan == 'onetimer') {
        parent.querySelector('.option-1 .variant__label').style.display = 'none';

        //Hide 30-days onetimer option
        if (document.querySelector('.variant-picker__wrapper.active .frequency__selector.selected').dataset.months == 1){
            document.querySelector('.variant-picker__wrapper.active .frequency__selector[data-months^="3"]').click();
        }
    }else{
        parent.querySelector('.option-1 .variant__label').style.display = 'flex';
    }

    changeVariantLabels(plan);
}

const changeVariantLabels = type => {
    let selected_variant_wrapper = document.querySelector('.variant-picker__wrapper.active');
    let selected_variant_labels = selected_variant_wrapper.querySelectorAll('.frequency__selector .variant__label-text p');

    selected_variant_labels.forEach(label => {
        label.dataset.type == type ? label.classList.remove('hidden') : label.classList.add('hidden');
    });
}

const parseProductDetails = event => {
    let selected_product = document.querySelector('.variant-picker__wrapper.active');
    let parsed_details = JSON.parse(selected_product.querySelector('script').textContent);
    return parsed_details;
}

const findSelectedVariant = parsed_details => { 
    let variant_id;
    let selling_plan_id = false;
    let selected_variant_wrapper = document.querySelector('.variant-picker__wrapper.active');
    let variant_selling_plan = selected_variant_wrapper.querySelector('.subscription__type.selected').dataset.type;
    let variant_package = selected_variant_wrapper.querySelector('.option-1 .variant__label.selected').dataset.option;
    let variant_days = selected_variant_wrapper.querySelector('.option-1 .variant__label.selected').dataset.days;
    let variant_option_2 = selected_variant_wrapper.querySelector('.option-2 .variant__label.selected')?.dataset.option ?? false;

    parsed_details.variants.forEach(variant => {
        if (variant.option2 == null  && variant.option1 == variant_package){
            variant_id = variant.id;
        }else if (variant.option2 != null  && variant.option2 == variant_option_2 && variant.option1 == variant_package){
            variant_id = variant.id;
        }
    });

    if (variant_selling_plan == 'subscription'){
        parsed_details.selling_plan_groups.forEach(plan => {
            //Recharge
            if (plan.name.indexOf(variant_days) > -1 && skioExist == false){
                selling_plan_id = plan.selling_plans[0].id;
            }
            //Skio
            if (plan.app_id == 'SKIO' && skioExist && plan.name != 'Dynamic Box Subscription'){
                plan.selling_plans.forEach(selling_plan => {
                    if (selling_plan.name.indexOf(variant_days) > -1){
                        selling_plan_id = selling_plan.id;
                        //console_log(selling_plan_id)
                    }
                });
            }
        });
    }
    updatePrice(variant_id);
    updateProductForm(variant_id, selling_plan_id)
}

const updateProductForm = (variant_id, selling_plan_id) =>{
    let form = document.querySelector('.variant-picker__wrapper.active form[data-type="add-to-cart-form"]');
    let input_id = form.querySelector('input[name="id"]');
    let input_selling_plan = form.querySelector('input[name="selling_plan"]') || false;

    input_id.setAttribute('value', variant_id);
    if (selling_plan_id){
        if(input_selling_plan){
            input_selling_plan.setAttribute('value', selling_plan_id);
        }else{
            let new_selling_input = document.createElement("input");
            new_selling_input.setAttribute('type', 'hidden');
            new_selling_input.setAttribute('id', 'selling_plan');
            new_selling_input.setAttribute('name', 'selling_plan');
            new_selling_input.setAttribute('value', parseInt(selling_plan_id));
            form.insertAdjacentElement('afterbegin', new_selling_input);
        }
    }else{
        input_selling_plan && input_selling_plan.remove();
    }
}



picker_triggers.forEach(el => el.addEventListener('click', openPickerModal));
close_triggers.forEach(el => el.addEventListener('click', closePickerModal));
//variant_picker_atc.forEach(el => el.addEventListener('click', closePickerModal));
picker_wrapper.length && picker_wrapper.forEach(el => el.addEventListener('click', closePickerModal));
picker_wrapper_section && picker_wrapper_section.addEventListener('click', closePickerModal);
variant_btns.forEach(el => el.addEventListener('click', setActiveBtn));
subscription_type_btns.forEach(el => el.addEventListener('click', checkSellingPlan));